import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { NgxSpinnerModule } from "ngx-spinner";
import { NotFoundComponent } from './views/not-found/not-found.component';
import { UnauthorizedComponent } from './views/unauthorized/unauthorized.component';
import {MatCardModule} from '@angular/material/card';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormComponent } from './views/form/form.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {MatDividerModule} from '@angular/material/divider';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSelectModule} from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import { FacPopupComponent } from './views/fac-popup/fac-popup.component';
import { AppConfirmService } from './services/app-confirm/app-confirm.service';
import { MatDialogModule } from "@angular/material/dialog";
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { HeaderComponent } from './views/header/header.component';
import { FooterComponent } from './views/footer/footer.component';

// App Modules
import { CoreModule } from './core/core.module';

// ============================================
// FE-01: Token Efímero para Formularios Públicos
// ============================================
// Para DESACTIVAR: Comenta las siguientes 2 líneas
import { EphemeralTokenInterceptor } from './security/ephemeral-token';
// ============================================

@NgModule({ declarations: [
        AppComponent,
        NotFoundComponent,
        UnauthorizedComponent,
        FormComponent,
        FacPopupComponent,
        HeaderComponent,
        FooterComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        CoreModule, // ⚠️ Importar SOLO UNA VEZ en AppModule
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        
        // Material Modules
        MatCardModule,
        MatDividerModule,
        MatDialogModule,
        MatSnackBarModule,
        MatButtonModule,
        MatSelectModule,
        MatFormFieldModule,
        MatInputModule,
        
        NgxSpinnerModule], providers: [
        // ============================================
        // FE-01: Token Efímero (ACTIVADO)
        // ============================================
        // ⚠️ IMPORTANTE: Debe ir ANTES de otros interceptors
        // Para DESACTIVAR: Comenta las siguientes 5 líneas
        {
            provide: HTTP_INTERCEPTORS,
            useClass: EphemeralTokenInterceptor,
            multi: true
        },
        // ============================================
        AppConfirmService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
